/* eslint-disable */
import {
  Admin,
  Club,
  
} from "@/models";

import api from "@/utils/backend-api";
import axios from 'axios';
import {
  closeNotice,
  commitPagination,
  sendErrorNotice,
  sendSuccessNotice
} from "@/utils/store-util";
import * as Cookies from 'js-cookie';
import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
// Internal
import clubs from "./modules/clubs";
import police from "./modules/polices";




Vue.use(Vuex);

export const store = new Vuex.Store({
  plugins:[createPersistedState({
    key:'su_admin'
  })],
  
  modules: {
    police,
    clubs

  },
  // plugins: [
  //   createPersistedState({
  //     getState: (key) => Cookies.getJSON(key),
  //     setState: (key, state) => Cookies.set(key, state, {
  //       expires: 3,
  //       secure: false
  //     })
  //   })
  // ],

  // modules: {
  //   clubs,
  //   police
  // },

  state: {

    user: null,
    token: null,
    modules:'',
    customers: [],
    notificationData:[],
    sideNav: true,
    customer: [],
    admin: new Admin(),
    club: new Club(),
    // police: new Police(),
    logsData: [],
    logs: [],
    earnings: [],
    earningData: [],
    earningtot:[],
    withdraw: [],
    withdrawData: [],
    CustomersData: [],
    adminpackages: [],
    loading: false,
    pagination: {},
    mode: "",
    snackbar: false,
    notice: "",
    showsidebar: '',
    startTime: [],
    closeTime: [],
    msg:'',
    success:false,
    testsList:[],
    questionsList:[],
    TestPackages:[],
    DraftQuestions:[],
    questionsCategories:[],
    //langCategories:[],
    questionsLangCategories:[],
    Notifications:[],
    NextNotificationUrl:''
  },

  mutations: {
    // loginLoading(state) {
    //     state.callingAPI = !state.callingAPI
    // },
    // globalSearching(state) {
    //     state.searching = state.searching === "" ? "loading" : ""
    // },
    setNotice(state, {
      notice
    }) {
      console.log(" notice .... ", notice);
      state.notice = notice;
    },
    setSnackbar(state, {
      snackbar
    }) {
      state.snackbar = snackbar;
    },
    setUser(state, user) {
      state.user = user
    },
    setadmin(state, admin) {
      state.admin = admin
    },
    setclub(state, club) {
      state.club = club
    },
    setRequestData(state, notificationData) {
      state.notificationData = notificationData
    },
    
    
      setModulesData (state, {modules}) {
        state.modules = modules
      },

    setToken(state, token) {
      state.token = token
    },
    setOrderList(state, orders) {
      state.orders = orders;
    },
    setCustomers(state, customers) {
      state.customers = customers;
    },
    setPagination(state, pagination) {
      state.pagination = pagination;
    },
    setLoading(state, {
      loading
    }) {
      state.loading = loading;
    },
    setNotice(state, {
      notice
    }) {
      console.log(" notice .... ", notice);
      state.notice = notice;
    },
    setSnackbar(state, {
      snackbar
    }) {
      state.snackbar = snackbar;
    },
    setMode(state, {
      mode
    }) {
      state.mode = mode;
    },
    setCustomer(state, {
      customer
    }) {
      state.customer = customer
    },
    setCustomersData(state, customers) {
      state.CustomersData = customers
    },

    setEarning(state, {
      earnings
    }) {
      state.earnings = earnings
    },

    setEarningsData(state, earnings) {
      state.earningData = earnings
    },

    setEarningstot(state, earningtot) {
      state.earningtot = earningtot
    },

    
    setWithdrawData(state, withdraw) {
      state.withdrawData = withdraw
    },

    setLogs(state, log) {
      state.logs = log
    },
    setLogsData(state, logs) {
      state.logsData = logs
    },
    setAdminPackages(state, adminPackages) {
      state.adminpackages = adminPackages;
    },
    setClubAdminNull(state) {
      state.club = new Club()
      state.admin = new Admin()
    },
    setMsg(state,{success,msg}) {
      state.success = success
      state.msg = msg
    },
    setTestList(state,{tests}) {
      state.testsList =tests
    },
    setQuestionsList(state,{questions}) {
      state.questionsList =questions
    },
    setQuestionsCategories(state,{questionsCategories}) {
      state.questionsCategories =questionsCategories
    },

    // setQuestionsLangCategories(state,{langCategories}) {
    //   state.langCategories =langCategories
    // },
    

    setQuestionsCategories(state,{questionsCategories}) {
      state.questionsCategories =questionsCategories
    },

    setQuestionsLangCategories(state,{questionsLangCategories}) {
      state.questionsLangCategories =questionsLangCategories
    },
   

    setTestPackages(state,{testPackages}) {
      state.TestPackages =testPackages
    },
    setDraftQuestions(state,{DraftQuestions}) {
      state.DraftQuestions =DraftQuestions
    },
    setNotificationData (state, Notifications) {
      state.Notifications = Notifications
    },
    setNextNotificationUrl(state, url) {
      state.NextNotificationUrl = url
    },
    pushNotificationData (state, Notifications) {
      let newNotifications=state.Notifications.concat(Notifications)
      state.Notifications=newNotifications
    },
  },
  getters: {

  },
  actions: {
    updateUser({
      commit
    }, {
      user,
      token
    }) {
      commit("setToken", token)
      commit("setUser", user)
    },
  
      setModulesData (state, {modules}) {
        state.modules = modules
      },
    logout({
      commit
    }) {
      commit("setNotice", {})
      commit("setSnackbar", {})
      commit("setUser", {})
      commit("setadmin", {})
      commit("setclub", {})
      commit("setToken", null)
      commit("setOrderList", {})
      commit("setCustomers", {})
      commit("setPagination", {})
      commit("setLoading", {})
      commit("setNotice", {})
      commit("setSnackbar", {})
      commit("setMode", {})
      commit("setCustomer", {})
      commit("setCustomersData", {})
      commit("setEarning", {})
      commit("setEarningsData", {})
      commit("setWithdrawData", {})
      commit("setLogs", {})
      commit("setLogsData", {})
      commit("setAdminPackages", {})
      commit("setQuestionsList", {})
      commit("setDraftQuestions", {})
      commit("setTests", {})
      commit("setTestPackages", {}) 
      
    },

    getAllCustomers({
      commit
    }) {
      commit("setLoading", {
        loading: true
      });

      api.getData("driver/club").then(res => {
        const result = res.data;
        commit("setCustomersData", result);

        const items = result.map(i => {
          if (i.admin_package == null) {
            var PackageName = "-"
          } else {
            var PackageName = i.admin_package.name
            console.log(PackageName)
          }
          return ({
            club_Id: i.id,
            status: i.user.status,
            admin: i.user.name,
            email: i.user.email,
            schoolName: i.club_name,
            package: PackageName,
            last_payment_request_amount: i.last_payment_request_amount,
            club_earnings: i.club_earnings,
            admin_id: i.admin_id,
            club_phone: i.club_phone
          })
        });

        commit("setCustomers", items);
        commitPagination(commit, result);
        commit("setLoading", {
          loading: false
        });
      });
    },

    getAllEarnings({
      commit
    }) {
      commit("setLoading", {
        loading: true
      });
      api.getData("driver/earning/statement").then(res => {
        const data = res.data;
        commit("setEarningsData", data)
        let items = [];
        //console.log(data[0]);
        for (let i = 0; i < data.length; i++) {
          /*items.push({
              date: data[i].date,
              payee_name: data[i].payee_name,
              payer_name: data[i].payer_name,
              deposit: data[i].deposit,
              withdraw: data[i].withdraw,
              balance: data[i].balance,
           //status: data[i].total_withdraw,
           });*/
        }
        console.log(items);
        commitPagination(commit, data);
        commit("setLoading", {
          loading: false
        });
      });
    },

    getAllClasses ({commit}) {
      return new Promise(function (resolve, reject) {
          api.postData('driver/viewModuleTemplate')
        .then((response) => {
          var modules = response.data
          commit('setModulesData', {modules})
          resolve(modules)
        }).catch((error) => {
          reject(error)
        })
      })
    },

    getCustomerById({
      commit
    }, id) {
      commit("setLoading", {
        loading: true
      });
      if (id) {
        api.getData("driver/club/" + id).then(
          res => {
            const customer = res.data;
            console.log("res.data")
            console.log(res.data)
            if (res.data.user.gender == "non_binary") {
              res.data.user.gender = "non-binary"
            }
            commit("setCustomer", {
              customer
            });
            commit("setLoading", {
              loading: false
            });
          },
          err => {
            console.log(err);
            commit("setLoading", {
              loading: false
            });
          }
        );
      } // else {
      //   commit("setCustomer", { customer: new Customer() });
      //   commit("setLoading", { loading: false });
      // }
    },
    /*     addAdmin({ commit, dispatch }, admin) {
             delete admin.address;
             if (!admin.id) {
                 api
                     .postData("driver/customer/create", admin)
                     .then(res => {
                         const admin = res.data.user;
                         commit("setadmin", { admin });
                         sendSuccessNotice(commit, "New admin has been added.");
                         closeNotice(commit, 1500);
                     })
                     .catch(err => {
                         console.log(err);
                         sendErrorNotice(commit, "Operation failed! Please try again later. ");
                         closeNotice(commit, 1500);
                     });
             } else {
                 api
                     .putData("admins/" + admin.id.toString(), admin)
                     .then(res => {
                         const admin = res.data;
                         commit("setadmin", { admin });
                         sendSuccessNotice(commit, "admin has been updated.");
                         closeNotice(commit, 1500);
                     })
                     .catch(err => {
                         console.log(err);
                         sendErrorNotice(commit, "Operation failed! Please try again later. ");
                         closeNotice(commit, 1500);
                     });
             }
         },*/
    /*addClub({ commit, dispatch }, club) {
        delete club.address;

        if (!club.id) {
            api
                .postData("driver/club/create", club)
                .then(res => {
                    const club = res.data;
                    commit("setclub", { club });
                    sendSuccessNotice(commit, "New club has been added.");
                    closeNotice(commit, 1500);
                })
                .catch(err => {
                    console.log(err);
                    sendErrorNotice(commit, "Operation failed! Please try again later. ");
                    closeNotice(commit, 1500);
                });
        } else {
            api
                .putData("club/" + club.id.toString(), club)
                .then(res => {
                    const club = res.data;
                    commit("setclub", { club });
                    sendSuccessNotice(commit, "Club has been updated.");
                    closeNotice(commit, 1500);
                })
                .catch(err => {
                    console.log(err);
                    sendErrorNotice(commit, "Operation failed! Please try again later.");
                    closeNotice(commit, 1500);
                });
        }
    },*/

    addAdmin({
      commit,
      dispatch
    }, admin) {
      console.log(admin);
      // delete admin.address;
      return new Promise((resolve, reject) => {
        if (true) {
          // admin['gender'] = admin['gender'].toLowerCase();
          console.log(admin);
          api.postData("driver/customer/create", admin)
            .then(res => {
              const adminRes = res.data.user;
              console.log(res.data.user);
              // commit("setadmin", { adminRes });
              commit("setadmin", {
                adminRes
              });

              sendSuccessNotice(commit, "New admin has been added.");
              closeNotice(commit, 1500);
              console.log("SetAdmin Success");
              console.log(this.admin);
              resolve(res);
            })
            .catch(err => {
              console.log(err);
              sendErrorNotice(commit, "Operation failed! Please try again later. ");
              closeNotice(commit, 1500);
            });
        } else {
          api
            .putData("admins/" + admin.id.toString(), admin)
            .then(res => {
              const admin = res.data;
              commit("setadmin", {
                admin
              });
              sendSuccessNotice(commit, "admin has been updated.");
              closeNotice(commit, 1500);
              resolve(res);
            })
            .catch(err => {
              console.log(err);
              sendErrorNotice(commit, "Operation failed! Please try again later. ");
              closeNotice(commit, 1500);
              resolve(res);
            });
        }
      })
    },

    addClub({commit,dispatch}, club) {
      // delete club.address;

      if (!club.id) {
        console.log(club);
        var formData = new FormData();
        formData.append('club_name', club.club_name);
        formData.append('club_email', club.club_email);
        formData.append('club_phone', club.club_phone);
        formData.append('city', club.city);
        formData.append('door', club.door);
        formData.append('floor', club.floor);
        formData.append('streetNumber', club.streetNumber);
        formData.append('zipCode', club.zipCode);
        formData.append('admin_id', club.admin_id);
        formData.append('admin_package_id', club.admin_package_id);
        // formData.append('description', club.description);
        // formData.append('benefit', club.benefit);
        // formData.append('attachment', club.attachment);
        // formData.append('start_date', club.start_date);
        // formData.append('opendays', club.opendays);
        // formData.append('club_start_time', club.club_start_time);
        // formData.append('club_end_time', club.club_end_time);
        // formData.append('club_logo', club.club_logo);
        // formData.append('club_cover', club.club_cover);
        formData.append('cvr_number', club.cvr_number);
        console.log(formData);
        api
          .postData("driver/club/create", formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(res => {
            const club = res.data;
            console.log(res.data);
            commit("setclub", {club});
            commit("setLoading", {loading: true});
            
            sendSuccessNotice(commit, "New club has been added.");
            dispatch('getAllCustomers')
            closeNotice(commit, 1500);
            // window.location.replace("/customers");
            // this.$router.push('/customers');
          })
          .catch(err => {
            console.log(err);
            sendErrorNotice(commit, "Operation failed! Please try again later. ");
            closeNotice(commit, 1500);
          });
      } else {
        api
          .putData("club/" + club.id.toString(), club)
          .then(res => {
            const club = res.data;
            commit("setclub", {
              club
            });
            sendSuccessNotice(commit, "Club has been updated.");
            closeNotice(commit, 1500);
          })
          .catch(err => {
            console.log(err);
            sendErrorNotice(commit, "Operation failed! Please try again later.");
            closeNotice(commit, 1500);
          });
      }
    },


  


    getLogs({
      commit
    }) {
      commit("setLoading", {
        loading: true
      });
      api.getData("driver/log").then(res => {
        const data = res.data;
        commit("setLogsData", data)
        console.log(data)

        commitPagination(commit, data);
        commit("setLoading", {
          loading: false
        });
      });
    },

    getAllWithdraw({
      commit
    }) {
      commit("setLoading", {
        loading: true
      });
      api.getData("driver/request").then(res => {
        const data = res.data;
        commit("setWithdrawData", data)
        let items = [];
        console.log(data[0]);
        for (let i = 0; i < data.length; i++) {
          /*items.push({
              date: data[i].date,
              payee_name: data[i].payee_name,
              payer_name: data[i].payer_name,
              deposit: data[i].deposit,
              withdraw: data[i].withdraw,
              balance: data[i].balance,
           //status: data[i].total_withdraw,
           });*/
        }
        //console.log(items);
        console.log(data);
        commitPagination(commit, data);
        commit("setLoading", {
          loading: false
        });
      });
    },

    // GetAllRequest({
    //   commit
    // }) {
    //   return new Promise(function (resolve, reject) {
    //     api.getData("driver/notification").then(res => {
    //       var notificationData = res.data.data;

    //       // console.log(results);
    //       // const items = results.map(j => {
    //       //   return ({
    //       //     date: j.date,
    //       //     payer_name: j.payer_name,
    //       //     payee_name: j.payee_name,
    //       //     deposit: j.deposit,
    //       //     withdraw: j.withdraw,
    //       //     balance: j.balance,
    //       //     description: j.description

    //       //   })
    //       // });
    //       commit("setRequestData", notificationData);
    //       resolve(res);
    //     });
    //   })
    // },

    loadAdminPackages({
      commit
    }) {
      api.getData("driver/product").then(res => {
        commit("setAdminPackages", res.data);
      });
    },
    adminEdit(dispatch, adminData) {
      var AdminDetails = adminData.adminData;
      var adminId = adminData.admin_id;
      console.log(AdminDetails);
      console.log(adminId);
      this.loading=true;
      api.postData("driver/admin/" + adminId, AdminDetails).then(res => {
        console.log(res);
      });
    },

    clubEdit(dispatch, ClubData) {
      var ClubDetails = ClubData.ClubData;
      var clubId = ClubData.club_id;
      console.log(ClubDetails);
      console.log(clubId);
      this.loading=true;
      api.postData("driver/club/" + clubId, ClubDetails).then(res => {
        console.log(res);
      });
    },
    /* getEarnings({commit}){
       commit("setLoading", { loading: true });
       api.getData("driver/earning/").then(res => {
           const data = res.data;
           commit("setEarningsData", data)
            let items=[];
            console.log(data[0]);
            commitPagination(commit, data);
           commit("setLoading", { loading: false });
       });
     },*/

    getEarningsTotalAmount({
      commit
    }) {
      commit("setLoading", {
        loading: true
      });
      api.getData("driver/earning").then(res => {
        const data = res.data;
        commit("setEarningstot", data)
        //let items = [];
        //console.log(data);
        commit("setLoading", {
          loading: false
        });
      });
    },

    resetAccount({
      commit
    }, email) {
      commit("setLoading", {
        loading: true
      });
      var formData = new FormData();
      formData.append('email', email);
      return new Promise(function (resolve, reject) {
        api.postData("auth/recovery", formData)
          .then(res => {
            console.log(res);

            if (res.status == 200) {
              console.log("Successfully reset 200")
              commit("setLoading", {
                loading: false
              });
              resolve(res.data);
            } else {
              console.log("error 404")
              commit("setLoading", {
                loading: false
              });
              reject(res.data);
            }
          })
          .catch(function (error) {
            console.log(error);
            commit("setLoading", {
              loading: false
            });
            reject(error);
          }).then(function () {
            reject("Done")
          })
      });
    },
    resetPassword({
      commit
    }, data) {
      console.log("resetPassword")
      console.log(data)
      return new Promise(function (resolve, reject) {
        api.postData("auth/reset", data)
          .then(res => {
            console.log(res);

            if (res.status == 200) {
              console.log("Successfully reset 200")
              commit("setLoading", {
                loading: false
              });
              resolve(res.data);
            } else {
              console.log("error 404")
              commit("setLoading", {
                loading: false
              });
              reject(res.data);
            }
          })
          .catch(function (error) {
            console.log(error);
            commit("setLoading", {
              loading: false
            });
            reject(error);
          }).then(function () {
            reject("Done")
          })
      });
    },
    changeClubStatus({
      commit
    }, Data) {
      api.postData("driver/admin/status/" + Data.adminid, {
          "status": Data.status
        })
        .then(res => {
          console.log(res);
        })
        .catch(function (error) {

        })

    },
    changeWithdrawStatus({commit}, Data) {
      console.log(Data)
      var url = ""
      switch (Data.status) {
        case "accept":
          url = "driver/request/accept/" + Data.id;
          break;
        case "paid":
          url = "driver/request/paid/" + Data.id;

          break;
      }
      console.log("url")
      console.log(url)
      api.postData(url, Data).then(res => {
        console.log(res)
      })
    },
    SidebarStatus(dispatch, value) {
      this.SidebarStatus = value;
    },
    confirmMail({commit}, id){
      console.log("confirmMail")
      console.log(id)
      new Promise(function(resolve,reject){
        api.getData("auth/confirmEmail/"+id)
        .then(res => {
          console.log(res);
          resolve(res)
          if(res.status==200){
            let success=false
            let msg="Your email already Confirmed"
            commit('setMsg',{success,msg})
          }else if(res.status==201){
            let success=true
            let msg="Your email has been verified"
            commit('setMsg',{success,msg})
          }else if(res.status==404){
            let success=false
            let msg="Url not found"
            console.log(success,msg)
            commit('setMsg',{success,msg})
          }else{
            let success=false
            let msg="Confirmation Failed"
            console.log(success,msg)
            commit('setMsg',{success,msg})
          }
        })
        .catch(function (error) {
          let success=false
          let msg="Url not found"
          console.log(success,msg)
          commit('setMsg',{success,msg})
        })

      })
    },
    verifyMail({commit}, id){
      console.log("confirmMail")
      console.log(id)
      new Promise(function(resolve,reject){
        api.getData("auth/changeEmail/"+id)
        .then(res => {
          console.log(res);
          resolve(res)
          if(res.status==200){
            let success=false
            let msg="Your email already Confirmed"
            commit('setMsg',{success,msg})
          }else if(res.status==201){
            let success=true
            let msg="Your email has been verified"
            commit('setMsg',{success,msg})
          }else if(res.status==404){
            let success=false
            let msg="Url not found"
            console.log(success,msg)
            commit('setMsg',{success,msg})
          }else{
            let success=false
            let msg="Confirmation Failed"
            console.log(success,msg)
            commit('setMsg',{success,msg})
          }
        })
        .catch(function (error) {
          let success=false
          let msg="Url not found"
          console.log(success,msg)
          commit('setMsg',{success,msg})
        })

      })
    },
    setTests({commit}, tests){
        commit('setTestList',{tests})
    },
    setQuestionsList({commit}, questions){
        commit('setQuestionsList',{questions})
    },
    setQuestionsCategories({commit}, questionsCategories){
        commit('setQuestionsCategories',{questionsCategories})
    },

    // setQuestionsLangCategories({commit}, questionsCategories){
    //   commit('setQuestionsCategories',{questionsCategories})
    // },

    setQuestionsLangCategories({commit}, questionsLangCategories){
      commit('setQuestionsLangCategories',{questionsLangCategories})
  },
    setTestPackages({commit}, testPackages){
        commit('setTestPackages',{testPackages})
    },
    setDraftQuestions({commit}, DraftQuestions){
        commit('setDraftQuestions',{DraftQuestions})
    },
    getAllNotifications ({commit}) {
      return new Promise(function (resolve, reject) {
        api.getData('driver/notification')
        .then((response) => {
          var Notifications = response.data.data
          let url=response.data.next_page_url
          commit('setNotificationData', Notifications)
          commit('setNextNotificationUrl', url)
          resolve(Notifications)
        }).catch((error) => {
          reject(error)
        })
      })
    },
    callNextNotifications({commit,state}){
      let url=state.NextNotificationUrl
      let config={
        headers:{
          'Authorization': 'Bearer '+Store.state.token
        }
      }
      axios.get(url,config)
      .then((response) => {
        var Notifications = response.data.data
        let url=response.data.next_page_url
        commit('setNextNotificationUrl', url)
        commit('pushNotificationData', Notifications)
      }).catch((error) => {
      })
    },
    pushLiveNotification({commit,state},data){
      let notification={
          date: JSON.parse(data.created_at).date.substring(0,19),
          from_user_id: '',
          id: '',
          message: data.notification_message,
          opposite_user_id: '',
          time: '',
          type: '1',
          user_id: data.admin_id?data.admin_id:'',
          user_image: data.user_image,
          user_name: data.user_name,

      }
        state.Notifications.unshift(notification)
        // commit('pushNotificationData', Notifications)
      
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js